module.exports = __webpack_public_path__ + "static/media/December2021.fc5871d4.pdf";